// Generated with util/create-component.js
import React from 'react';

import { ITableFootProps } from './Foot.types';

const Foot = ({ children }: ITableFootProps) => (
  <tfoot className="rrui-table__foot">{children}</tfoot>
);

export default Foot;
